"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessAttributeDomain = void 0;
var AccessAttributeDomain;
(function (AccessAttributeDomain) {
    AccessAttributeDomain["TechnicalProject"] = "TechnicalProject";
    AccessAttributeDomain["Act"] = "Act";
    AccessAttributeDomain["Supply"] = "Supply";
    AccessAttributeDomain["Regulation"] = "Regulation";
    AccessAttributeDomain["Counterparty"] = "Counterparty";
    AccessAttributeDomain["Tool"] = "Tool";
    AccessAttributeDomain["User"] = "User";
})(AccessAttributeDomain = exports.AccessAttributeDomain || (exports.AccessAttributeDomain = {}));
//# sourceMappingURL=access-attribute.type.js.map